const accordion = {
  hidden: {
    height: 0,
    opacity: 0,
  },
  visible: {
    height: 'auto',
    opacity: 1,
    transition: {
      duration: 0.1,
      type: 'spring',
      damping: 20,
      stiffness: 100,
    },
  },
  exit: {
    height: 0,
    opacity: 0,
  },
};

export default accordion;
